import * as React from "react";
import { createColumn, createCheckboxColumn, createDropdownColumn, createMultiValueDropdownColumn } from "../components/Table/Table";
import { createBitMaskValue, formatBitMaskString } from "../utils/utils";
import Binary from "../components/Binary/Binary";

export const baseEnumColumns: State.Column[] = [
  createColumn(
    "Value",
    (enumeration: Api.BaseEnumeration) => enumeration.enumValue,
    "enumeration.enumValue",
    true,
    80
  ),
  createColumn(
    "Enumeration",
    (enumeration: Api.BaseEnumeration) => enumeration.enumName,
    "enumeration.enumName",
    true
  ),
  createColumn(
    "Comment",
    (enumeration: Api.BaseEnumeration) => enumeration.comment,
    "enumeration.comment",
    true
  )
];

const liftEventEnumAuditColumns: State.Column[] = [
  createColumn(
    "Created By",
    (enumeration: Api.LiftEventEnumeration) => enumeration.createdBy,
    "enumeration.createdBy",
    false
  ),
  createColumn(
    "Created Date",
    (enumeration: Api.LiftEventEnumeration) => enumeration.createdDate,
    "enumeration.createdDate",
    false
  ),
  createColumn(
    "Modified By",
    (enumeration: Api.LiftEventEnumeration) => enumeration.modifiedBy,
    "enumeration.modifiedBy",
    false
  ),
  createColumn(
    "Modified Date",
    (enumeration: Api.LiftEventEnumeration) => enumeration.modifiedDate,
    "enumeration.modifiedDate",
    false
  )
];

export const liftEventEnumColumns: State.Column[] = [
  ...baseEnumColumns,
  ...liftEventEnumAuditColumns
];

export const electrificationColumns: State.Column[] = [
  ...baseEnumColumns,
  createColumn(
    "Created By",
    (enumeration: Api.Electrification) => enumeration.createdBy,
    "enumeration.createdBy",
    false
  ),
  createColumn(
    "Created Date",
    (enumeration: Api.Electrification) => enumeration.createdDate,
    "enumeration.createdDate",
    false
  ),
  createColumn(
    "Modified By",
    (enumeration: Api.Electrification) => enumeration.modifiedBy,
    "enumeration.modifiedBy",
    false
  ),
  createColumn(
    "Modified Date",
    (enumeration: Api.Electrification) => enumeration.modifiedDate,
    "enumeration.modifiedDate",
    false
  )
];
export const messageTypeColumns: State.Column[] = [
  createColumn(
    "Value",
    (messageType: Api.MessageType) => messageType.enumValue,
    "messageType.enumValue",
    true,
    80
  ),
  createColumn(
    "Enumeration",
    (messageType: Api.MessageType) => messageType.enumName,
    "messageType.enumName",
    true
  ),
  createDropdownColumn(
    "Event Class",
    (messageType: Api.MessageType) => messageType.mapping?.eventClass ? messageType.mapping.eventClass.enumName : "",
    "messageType.mapping.eventClass.enumName",
    true,
    240
  ),
  createMultiValueDropdownColumn(
    "Event Types",
    (messageType: Api.MessageType) =>
      messageType.mapping?.eventTypes ? messageType.mapping.eventTypes.map(et => et.enumName).join(", ") : "",
    "messageType.mapping.eventTypes",
    true
  ),
  createCheckboxColumn(
    "Mapping Available",
    (messageType: Api.MessageType) => messageType.mappingNeeded,
    "messageType.mappingNeeded",
    true,
    80
  ),
  createColumn(
    "Comment",
    (messageType: Api.MessageType) => messageType.comment,
    "messageType.comment",
    true
  ),
  createColumn(
    "Created By",
    (messageType: Api.MessageType) => messageType.createdBy,
    "messageType.createdBy",
    false
  ),
  createColumn(
    "Created Date",
    (messageType: Api.MessageType) => messageType.createdDate,
    "messageType.createdDate",
    false
  ),
  createColumn(
    "Modified By",
    (messageType: Api.MessageType) => messageType.modifiedBy,
    "messageType.modifiedBy",
    false
  ),
  createColumn(
    "Modified Date",
    (messageType: Api.MessageType) => messageType.modifiedDate,
    "messageType.modifiedDate",
    false
  )
];
export const messageTypeEventTypeColumns: State.Column[] = [
  createColumn(
    "Enumeration",
    (eventType: Api.BaseEnumeration) => `${eventType.enumName} [${eventType.enumValue}]`,
    "eventType.enumName",
    true
  )
];
export const messageTypeEventTypeColumnsWithRemove: State.Column[] = [
  createColumn(
    "Enumeration",
    (eventType: Api.BaseEnumeration) => `${eventType.enumName} [${eventType.enumValue}]`,
    "eventType.enumName",
    true
  )
];
// Audit columns shared across IO enumeration tables (hidden by default)
const ioEnumAuditColumns: State.Column[] = [
  createColumn(
    "Created By",
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (enumeration: any) => enumeration.createdBy,
    "enumeration.createdBy",
    false
  ),
  createColumn(
    "Created Date",
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (enumeration: any) => enumeration.createdDate,
    "enumeration.createdDate",
    false
  ),
  createColumn(
    "Modified By",
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (enumeration: any) => enumeration.modifiedBy,
    "enumeration.modifiedBy",
    false
  ),
  createColumn(
    "Modified Date",
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (enumeration: any) => enumeration.modifiedDate,
    "enumeration.modifiedDate",
    false
  )
];

export const ioDatatypeColumns: State.Column[] = [
  createColumn(
    "Value",
    (enumeration: Api.ioDataType) => enumeration.value,
    "enumeration.value",
    true
  ),
  createColumn(
    "Enumeration",
    (enumeration: Api.ioDataType) => enumeration.enumName,
    "enumeration.enumName",
    true
  ),
  createColumn(
    "Comment",
    (enumeration: Api.ioDataType) => enumeration.comment,
    "enumeration.comment",
    true
  ),
  ...ioEnumAuditColumns
];
export const ioOptionColumns: State.Column[] = [
  createColumn(
    "Value",
    (enumeration: Api.ioOption) => enumeration.value,
    "enumeration.value",
    true
  ),
  createColumn(
    "Enumeration",
    (enumeration: Api.ioOption) => enumeration.enumName,
    "enumeration.enumName",
    true
  ),
  createColumn(
    "Comment",
    (enumeration: Api.ioOption) => enumeration.comment,
    "enumeration.comment",
    true
  ),
  ...ioEnumAuditColumns
];
export const ioBoardTypeColumns: State.Column[] = [
  createColumn(
    "Type ID",
    (enumeration: Api.IoBoardType) => enumeration.boardTypeId,
    "enumeration.boardTypeId",
    true,
    80
  ),
  createColumn(
    "Enumeration",
    (enumeration: Api.IoBoardType) => enumeration.enumName,
    "enumeration.enumName",
    true
  ),
  createColumn(
    "Comment",
    (enumeration: Api.IoBoardType) => enumeration.comment,
    "enumeration.comment",
    true
  ),
  createCheckboxColumn(
    "Multinet",
    (enumeration: Api.IoBoardType) => enumeration.isMultiNet,
    "enumeration.isMultiNet",
    true
  ),
  createColumn(
    "Install Order",
    (enumeration: Api.IoBoardType) => enumeration.installOrder == null ? 0 : enumeration.installOrder,
    "enumeration.installOrder",
    true
  ),
  ...ioEnumAuditColumns
];
export const ioBoardTypeColumnsForBoardEditor: State.Column[] = [
  createColumn(
    "ID",
    (enumeration: Api.IoBoardType) => enumeration.boardTypeId,
    "enumeration.boardTypeId",
    true
  ),
  createColumn(
    "Board Type",
    (enumeration: Api.IoBoardType) => enumeration.enumName,
    "enumeration.enumName",
    true
  ),
  createColumn(
    "Comment",
    (enumeration: Api.IoBoardType) => enumeration.comment,
    "enumeration.comment",
    true
  )
];
export const ioBasicDataTypeColumns: State.Column[] = [
  createColumn(
    "Value",
    (enumeration: Api.IoBasicDataType) => enumeration.enumValue,
    "enumeration.enumValue",
    true
  ),
  createColumn(
    "Enumeration",
    (enumeration: Api.IoBasicDataType) => enumeration.enumName,
    "enumeration.enumName",
    true
  ),
  createColumn(
    "Comment",
    (enumeration: Api.IoBasicDataType) => enumeration.comment,
    "enumeration.comment",
    true
  ),
  ...ioEnumAuditColumns
];

/** IO CPU columns – base enum columns extended with hidden audit fields */
export const ioCpuColumns: State.Column[] = [
  ...baseEnumColumns,
  ...ioEnumAuditColumns
];

/** IO Network columns – base enum columns extended with hidden audit fields */
export const ioNetworkColumns: State.Column[] = [
  ...baseEnumColumns,
  ...ioEnumAuditColumns
];

export const ioDataSectionColumns: State.Column[] = [
  createColumn(
    "Section",
    (enumeration: Api.IodataSections) => enumeration.name,
    "enumeration.name",
    true
  ),
  {
    ...createColumn(
      "Mask",
      (enumeration: Api.IodataSections) => <Binary value={createBitMaskValue(enumeration.mask)} />,
      "enumeration.mask",
      true
    ),
    exportAccessor: (enumeration: Api.IodataSections) => formatBitMaskString(enumeration.mask)
  },
  createColumn(
    "Bound Enum",
    (enumeration: Api.IodataSections) =>
      enumeration.enumeration ? enumeration.enumeration.name : "",
    "enumeration.enumeration",
    true
  ),
  ...ioEnumAuditColumns
];
export const ioDataSectionColumnsWithRemove: State.Column[] = [
  createColumn(
    "Section",
    (enumeration: Api.IodataSections) => enumeration.name,
    "enumeration.name",
    true
  ),
  {
    ...createColumn(
      "Mask",
      (enumeration: Api.IodataSections) => <Binary value={createBitMaskValue(enumeration.mask)} />,
      "enumeration.mask",
      true,
      320,
      320
    ),
    exportAccessor: (enumeration: Api.IodataSections) => formatBitMaskString(enumeration.mask)
  },
  createColumn(
    "Bound Enum",
    (enumeration: Api.IodataSections) =>
      enumeration.enumeration ? enumeration.enumeration.name : "",
    "enumeration.enumeration",
    true
  ),
  ...ioEnumAuditColumns
];

/** IO Data Sections columns for selection modal – no audit columns */
export const ioDataSectionColumnsSelect: State.Column[] = [
...ioDataSectionColumns
];

export const IoOptionsEnumTypeColumns: State.Column[] = [
  createColumn(
    "EnumID",
    (enumeration: Api.IoOptionsEnumType) => enumeration.enumID,
    "enumeration.enumID",
    true
  ),
  createColumn(
    "Enum Type Name",
    (enumeration: Api.IoOptionsEnumType) => enumeration.enumTypeName,
    "enumeration.enumName",
    true
  ),
  ...ioEnumAuditColumns
];

const DateUserColumn: State.Column[] = [
  createColumn("Created By", (dataAct: Api.DataActCode) => dataAct.createdBy, "dataAct.createdBy", false),
  createColumn(
    "Created Date",
    (dataAct: Api.DataActCode) => dataAct.createdDate,
    "dataAct.createdDate",
    false
  ),
  createColumn("Modified By", (dataAct: Api.DataActCode) => dataAct.modifiedBy, "dataAct.modifiedBy", false),
  createColumn(
    "Modified Date",
    (dataAct: Api.DataActCode) => dataAct.modifiedDate,
    "dataAct.modifiedDate",
    false
  )
];

export const DataActCodeColumns: State.Column[] = [
  createColumn(
    "Code",
    (enumeration: Api.DataActCode) => enumeration.code,
    "enumeration.code",
    true
  ),
  createColumn(
    "Name",
    (enumeration: Api.DataActCode) => enumeration.name,
    "enumeration.name",
    true
  ),
  ...DateUserColumn
];
